import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"

// Takes `reviews` from the parent instead of fetching independently - see
// ReviewsSummary.js for why.
const RatingsTrend = ({ reviews = [] }) => {
  const [chartOptions, setChartOptions] = useState({
    options: {
      colors: ["#2990DF", "#e76f51"],
      chart: {
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 1.5,
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      legend: {
        show: true,
      },
    },
    series: [],
  })

  useEffect(() => {
    if (reviews && reviews.length > 0) {
      const monthlyRatings = {}
      const months = new Set()

      reviews.forEach(review => {
        const reviewMonth = new Date(review.reviewDate).toLocaleString(
          "default",
          { month: "short", year: "numeric" },
        )

        months.add(reviewMonth)

        if (!monthlyRatings[reviewMonth]) {
          monthlyRatings[reviewMonth] = { totalRating: 0, reviewCount: 0 }
        }

        const rating = parseFloat(review.rating)
        if (!isNaN(rating)) {
          monthlyRatings[reviewMonth].totalRating += rating
          monthlyRatings[reviewMonth].reviewCount += 1
        }
      })

      const sortedMonths = Array.from(months).sort(
        (a, b) => new Date(a) - new Date(b),
      )

      const averageRatings = sortedMonths.map(month => {
        const monthData = monthlyRatings[month]
        return monthData
          ? (monthData.totalRating / monthData.reviewCount).toFixed(2)
          : 0
      })

      setChartOptions(prevOptions => ({
        ...prevOptions,
        options: {
          ...prevOptions.options,
          xaxis: {
            ...prevOptions.options.xaxis,
            categories: sortedMonths,
          },
        },
        series: [
          {
            name: "Average Rating",
            data: averageRatings,
          },
        ],
      }))
    } else {
      setChartOptions(prevOptions => ({
        ...prevOptions,
        options: {
          ...prevOptions.options,
          xaxis: { ...prevOptions.options.xaxis, categories: [] },
        },
        series: [],
      }))
    }
  }, [reviews])

  return (
    <React.Fragment>
      <Card
        className="br"
        style={{
          overflowY: "auto",
          minHeight: "453px",
          maxHeight: "453px",
          marginBottom: "1rem",
        }}
      >
        <CardBody>
          <h4 className="card-title mb-4">Google Ratings Trends</h4>

          <Row className="text-center mt-4">
            <Col xs="12">
              <p className="text-muted">
                This chart displays the monthly average ratings for Google
                reviews.
              </p>
            </Col>
          </Row>

          <div
            id="google-ratings-chart"
            className="morris-charts morris-charts-height"
            dir="ltr"
          >
            <ReactApexChart
              options={chartOptions.options}
              series={chartOptions.series}
              type="line"
              height="300"
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default RatingsTrend
